import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../../../components/ui/card";
import { Input } from "../../../components/ui/input";
import { Button } from "../../../components/ui/button";
import Table2 from "../../../components/table/table-2";
import { EyeOff, Eye, Check, X, Heart, Ambulance } from "lucide-react";
import { useEffect, useState } from "react";
import FormRenderer from "../../../components/input-field/form-renderer";
import { isFormValid } from "../../../utils/validators";
import { columns, data } from "../../../data/admin/role/create-employee";
import { createPatientfields } from "../../../config/role/create-patient";
import { createPatientSignup } from "../../../services/patient/patientAuthService";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getAllBranch } from "../../../services/admin/branch-service";
import Loader from "../../../components/loader/loader";
import {
  changePatientStatus,
  getAllPatient,
  getPatientById,
} from "../../../services/patient/patientDetailService";
import { useGetAllBranches } from "../../../hook/admin/use-branch";
import ViewPatientDataByID from "../../../components/viewsModals/viewPatientDetailsById";
import { useGetAllRoles } from "../../../hook/admin/use-role";
import { showSuccessToast, showErrorToast,} from "../../../utils/toast-utils";


const CreatePatient = () => {
  const queryClient = useQueryClient();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [form, setForm] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPasswordError, setShowPasswordError] = useState("");
  const [branchId, setBranchId] = useState("");
  const [showSignupLoader, setShowSignupLoader] = useState(false);
  const [patientSignupResponse, setPatientSignupResponse] = useState(null);
  const [closeMessage, setCloseMessage] = useState(false);
  const [viewPatientLoading, setViewpatientLoading] = useState(null);
  const [viewPatientData, setViewPatientData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(5);

  const patientColumns = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Mobile", key: "mobile" },
    { label: "Gender", key: "gender" },
    { label: "DOB", key: "dob" },
    {
      label: "Status",
      key: "isActive",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${row.isActive
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
            }`}
        >
          {row.isActive ? "Active" : "Inactive"}
        </span>
      ),
    },

    {
      label: "Actions",
      key: "actions",
      render: (row) => (
        <div className="flex gap-2">
          <button
            onClick={() => handleView(row.id)}
            className="px-2 py-1 text-xs bg-blue-100 text-blue-600 rounded hover:bg-blue-200"
          >
            View
          </button>
        </div>
      ),
    },
    {
      key: "isActive",
      label: "Status",
      render: (row) => (
        <button
          onClick={() => handleStatus(row)}
          className={`rounded-full border h-[28px] w-[50px] text-xs font-semibold items-center flex transition-all duration-200 ${row.isActive
            ? "border-blue-700 bg-blue-100 justify-end"
            : "border-gray-400 bg-gray-100 justify-start"
            }`}
        >
          <span
            className={`inline-block h-[22px] w-[22px] rounded-full transition-all duration-200 ${row.isActive ? "bg-blue-700" : "bg-gray-400"
              }`}
          ></span>
        </button>
      ),
    },
    {
      label: "Created",
      key: "created_at",

      render: (row) => <span>{new Date(row.created_at).toLocaleString()}</span>,
    },
  ];

  const handleView = async (id) => {
    if (!id) return;

    setViewpatientLoading(true);

    try {
      const res = await getPatientById({ id });
      console.log(res);
      setViewPatientData(res);
    } catch (error) {
      console.log(error);
    } finally {
      setViewpatientLoading(false);
    }
  };

  const { data: branches = [], isLoading: branchLoading } = useGetAllBranches();
  const { data: roles = [], isLoading: rolesLoading } = useGetAllRoles();

  const {
    data: allPatientDetails,
    isLoading: isPatientDetailsLoading,
    error: getPatientError,
  } = useQuery({
    queryKey: ["getAllPatient", currentPage, limit],
    queryFn: async () => {
      return await getAllPatient({ limit, page: currentPage });
    },
  });

  const handleCreatePatient = async () => {
    if (!password) {
      return setShowPasswordError("Please enter password");
    } else if (!confirmPassword) {
      return setShowPasswordError("Please confirm password");
    } else if (!branchId) {
      return setShowPasswordError("Please select branch ID");
    }

    if (password !== confirmPassword) {
      return setShowPasswordError("Please confirm password");
    }

    setShowPasswordError("");

    const payload = {
      ...form,
      role: "patient",
      password,
      hospital_branch_id: branchId,
    };

    setShowSignupLoader(true);

    try {
      const res = await createPatientSignup(payload);

      if (res?.data?.status === 201) {
        setPatientSignupResponse(res.data);
        setForm({});
        setPassword("");
        setConfirmPassword("");
        showSuccessToast(res?.data?.message || res?.message);
      }
      queryClient.invalidateQueries({
          queryKey: ["getAllPatient"],
      });
      
    } catch (error) {
      console.log(error);
    } finally {
      setShowSignupLoader(false);
    }
  };

  const handleStatus = async (row) => {
    setShowSignupLoader(true);

    try {
      const res = await changePatientStatus({
        id: row.id,
        isActive: !row.isActive,
      });

      if (res?.status === 200 || res?.data?.status === 200) {
        showSuccessToast(
          res?.data?.message ||
          res?.data?.data?.message ||
          "Status updated successfully"
        );

        queryClient.invalidateQueries({
          queryKey: ["getAllPatient"],
        });
      } else {
        showErrorToast(
          res?.data?.message ||
          res?.data?.data?.message ||
          "Something went wrong"
        );
      }
    } catch (error) {
      console.log("Change patient status error:", error);

      showErrorToast(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to update patient status"
      );
    } finally {
      setShowSignupLoader(false);
    }
  };
  return (
    <div className="sm:p-2">
      {(branchLoading ||
        isPatientDetailsLoading ||
        showSignupLoader ||
        viewPatientLoading) && <Loader />}
      <h2 className="text-xl flex ml-4 items-center justify-start gap-2 md:text-2xl text-black font-bold mb-4 md:mb-8">
        <Ambulance className="text-purple-700" /> Create Patient
      </h2>
      <div className="grid grid-cols-1 gap-8">
        <Card className=" rounded-xl bg-white  border-none ">
          <div className="flex flex-col p-2 sm:p-6">
            <div className="w-full">
              <FormRenderer
                fields={createPatientfields}
                values={form}
                setValues={setForm}
              />
            </div>

            <div className="w-full grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2 mt-4 ">
              {/* Role */}
             
              <div className=" w-full flex col-span-2 md:col-span-1 flex-col gap-2">
                <label
                  htmlFor="branchId"
                  className=" text-gray-700 font-semibold "
                >
                  Select Branch ID
                </label>

                <select
                  name="branchId"
                  value={branchId}
                  onChange={(e) => setBranchId(e.target.value)}
                  required
                  id="branchId"
                  className=" py-2 border rounded-md"
                >
                  <option value="">Select</option>
                  {Array.isArray(branches) &&
                    branches.map((item, index) => (
                      <option key={index} value={item.hospitalId}>
                        {item.hospitalId}
                      </option>
                    ))}
                </select>
              </div>

              <div className=" w-full flex col-span-2 md:col-span-1 flex-col gap-2 ">
                <label className="font-semibold text-gray-700">Password</label>
                <div className="relative ">
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <Button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    variant="admin.default"
                    className="absolute text-blue-600 right-[1px] -translate-y-1/2  top-[22px] px-2"
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </Button>
                </div>
              </div>

              <div className=" w-full flex col-span-2 md:col-span-1 flex-col gap-2 ">
                <div>
                  <label className="font-semibold text-gray-700">
                    Confirm Password
                  </label>
                </div>

                <div className="relative ">
                  <Input
                    type={showConfirmPassword ? "text" : "password"}
                    name="Confirm Password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />

                  <Button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    variant="admin.default"
                    className="absolute text-blue-600 right-[1px] -translate-y-1/2  top-[22px] px-2"
                  >
                    {showConfirmPassword ? (
                      <EyeOff size={18} />
                    ) : (
                      <Eye size={18} />
                    )}
                  </Button>
                </div>
              </div>
            </div>

            {showPasswordError && (
              <div className="w-full text-red-600">{showPasswordError}</div>
            )}

            <div className="col-12 mt-3">
              <Button
                onClick={handleCreatePatient}
                variant="admin.secondary"
                disabled={!isFormValid(createPatientfields, form)}
              >
                Submit
              </Button>
            </div>

            {patientSignupResponse?.status === 201 && !closeMessage && (
              <div className="mt-4 flex items-center justify-between gap-3 rounded-xl border border-green-200 bg-green-50 px-4 py-3 shadow-sm animate-fade-in">
                <div className="flex justify-center items-center gap-4">
                  <div className="flex h-8 w-8 items-center justify-center rounded-full bg-green-100">
                    <Check className="h-5 w-5 text-green-600" />
                  </div>

                  <div className="flex flex-col">
                    <p className="text-sm font-semibold text-green-700">
                      Success
                    </p>
                    <p className="text-sm text-green-600">
                      {patientSignupResponse?.message ||
                        patientSignupResponse?.data?.message ||
                        "Patient Created Successfully"}
                    </p>
                  </div>
                </div>

                <button onClick={() => setCloseMessage(true)} className="">
                  <X />
                </button>
              </div>
            )}
          </div>
        </Card>

        {viewPatientData && (
          <ViewPatientDataByID
            viewPatientData={viewPatientData?.data?.data}
            setViewPatientData={setViewPatientData}
          />
        )}

        <Card className="rounded-xl border-none bg-white ">
          <div className="flex px-4 md:px-8 items-center w-full justify-between">
            <CardTitle className="text-md md:text-xl text-gray-600">
              All Patients
            </CardTitle>
            <div className="flex flex-col pt-2 gap-1">
              <label className="font-semibold" htmlFor="limit">
                Select Limit
              </label>
              <select
                onChange={(e) => setLimit(e.target.value)}
                className="w-[150px] p-2 border bg-gradient-to-r from-blue-600 to-purple-700 text-white font-semibold rounded-lg"
                name=""
                id="limit"
              >
                <option className="bg-purple-800 text-white" value="5">
                  5
                </option>
                <option className="bg-purple-800 text-white" value="10">
                  10
                </option>
                <option className="bg-purple-800 text-white" value="20">
                  20
                </option>
                <option className="bg-purple-800 text-white" value="50">
                  50
                </option>
                <option className="bg-purple-800 text-white" value="100">
                  100
                </option>
              </select>
            </div>
          </div>
          <CardContent className="pl-4 text-[#081a3a] font-bold">
            <Table2
              columns={patientColumns}
              data={allPatientDetails?.data?.data?.rows}
              rowsPerPage={4}
            />

            <div className="w-full flex justify-center items-center py-4 gap-4">
              <Button
                onClick={() => setCurrentPage((prev) => prev - 1)}
                disabled={currentPage === 1}
                variant="admin.secondary"
              >
                prev
              </Button>

              <div>
                Page {allPatientDetails?.data?.data?.currentPage} of{" "}
                {allPatientDetails?.data?.data?.totalPages}
              </div>

              <Button
                onClick={() => setCurrentPage((prev) => prev + 1)}
                disabled={
                  allPatientDetails?.data?.data?.totalPages === currentPage
                }
                variant="admin.secondary"
              >
                next
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CreatePatient;
